/* ── Bad Bunzy Track Order — bb-track-order.js ── */

(function () {
  'use strict';

  function initTrackOrder() {
    var form      = document.getElementById('bbto-form');
    var orderInput = document.getElementById('bbto-order-num');
    var emailInput = document.getElementById('bbto-email');
    var errorEl   = document.getElementById('bbto-error');
    var loadingEl = document.getElementById('bbto-loading');
    var resultEl  = document.getElementById('bbto-result');

    if (!form) return;

    // Allow Enter key from either field
    [orderInput, emailInput].forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitTrack(); }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitTrack();
    });

    function submitTrack() {
      var orderNum = orderInput ? orderInput.value.trim() : '';
      var email    = emailInput ? emailInput.value.trim() : '';

      hideAll();

      // Validate
      if (!orderNum || !email) {
        showError('Please enter both your order number and email address.');
        return;
      }
      if (!email.includes('@') || !email.includes('.')) {
        showError('Please enter a valid email address.');
        return;
      }

      var trackingUrl = form.dataset.trackingUrl || '';

      if (trackingUrl) {
        // Has a tracking app configured — redirect to it with params
        showLoading();
        var sep = trackingUrl.includes('?') ? '&' : '?';
        var dest = trackingUrl
          + sep
          + 'order_number=' + encodeURIComponent(orderNum)
          + '&email=' + encodeURIComponent(email);

        // Small delay so loading state is visible
        setTimeout(function () {
          window.location.href = dest;
        }, 600);
      } else {
        // No tracking app configured — check if customer is logged in
        // and redirect to their account orders page
        var isLoggedIn = document.body.classList.contains('customer-logged-in')
          || document.querySelector('.bbto-page').dataset.customerLoggedIn === 'true';

        if (isLoggedIn) {
          showLoading();
          setTimeout(function () {
            window.location.href = '/account/orders';
          }, 600);
        } else {
          // Not logged in, no app — show helpful fallback
          showError(
            form.dataset.fallbackMsg ||
            'To track your order, please log in to your account or contact us at support@badbunzygolf.com with your order number.'
          );
        }
      }
    }

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.classList.add('show');
      }
      if (resultEl) resultEl.classList.remove('show');
    }

    function showLoading() {
      if (loadingEl) loadingEl.classList.add('show');
    }

    function hideAll() {
      if (errorEl)   errorEl.classList.remove('show');
      if (loadingEl) loadingEl.classList.remove('show');
      if (resultEl)  resultEl.classList.remove('show');
    }
  }

  // ── FAQ ACCORDION ──
  function initFaq() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bbto-faq-btn');
      if (!btn) return;

      var answer = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');

      // Close all
      document.querySelectorAll('.bbto-faq-btn').forEach(function (b) {
        b.classList.remove('open');
        var tog = b.querySelector('.bbto-faq-toggle');
        if (tog) tog.textContent = '+';
        var ans = b.nextElementSibling;
        if (ans) ans.classList.remove('open');
      });

      // Open clicked (if it was closed)
      if (!isOpen && answer) {
        btn.classList.add('open');
        var toggle = btn.querySelector('.bbto-faq-toggle');
        if (toggle) toggle.textContent = '×';
        answer.classList.add('open');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTrackOrder();
      initFaq();
    });
  } else {
    initTrackOrder();
    initFaq();
  }
})();
